export default __webpack_public_path__ + "static/media/flagItaly.1e8e097a.svg";